import {computed, Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Patient} from '../../shared/models/patient.obj';
import {Intervention} from '../../shared/models/intervention.obj';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class PatientProfileDataService {
	public patient = signal<Patient>(null);
	public interventions = signal<Intervention[]>([]);

	public doctorContacts = computed(() =>
		this.patient().contacts.filter(contact => contact.isDoctor === true)
	);

	public professionalContacts = computed(() =>
		this.patient().contacts.filter(contact => contact.isDoctor !== true)
	);


	constructor(private http: HttpClient) {}

	loadPatient(id: number): Observable<Patient> {
		return this.http.get<Patient>(`/api/scap/patient/${id}`).pipe(
			tap(data => {
				this.patient.set(data);
				MoConsole.log('load patient() = ', data);
				// Automatically load interventions when patient is updated
				this.loadInterventions();
			})
		);
	}

	loadInterventions() {
		if (!this.patient().id) {
			MoConsole.warn('Patient ID is not available.');
			return;
		}

		this.http.get<Intervention[]>(`/api/scap/patient/${this.patient().id}/interventions`)
			.pipe(
				tap(interventions => this.interventions.set(interventions))
			).subscribe(
			() => {},
			() => this.interventions.set([])
		);
	}

	invalidateCurrentData(): Promise<void> {
		this.patient.set(null);
		this.interventions.set(null);
		return Promise.resolve();
	}
}
